import { Permissions } from "../types/User";

export type NavigationItem = {
  key: string;
  label: string;
  path: string;
};

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { key: "1", label: "Dashboard", path: "/dashboard" },
  { key: "16", label: "Check Feedback", path: "/feedback-users" },
  { key: "2", label: "Manage Customers", path: "/manageusers" },
  {
    key: "3",
    label: "Manage Subscription Plans",
    path: "/manage-subscription",
  },
  { key: "4", label: "Manage Categories", path: "/manage-categories" },
  {
    key: "5",
    label: "Set Points Criteria",
    path: "/set-points-criteria",
  },
  {
    key: "6",
    label: "Manage Savings Limit",
    path: "/manage-savings-limit",
  },
  { key: "7", label: "Manage Round Up", path: "/manage-round-up" },
  { key: "8", label: "Manage Marketplace", path: "/manage-banner" },
  { key: "9", label: "Manage Email Templates", path: "/manage-emails" },
  {
    key: "10",
    label: "Manage Notifications",
    path: "/manage-notifications",
  },
  { key: "11", label: "Reports and Analytics", path: "/analytics" },
  { key: "12", label: "Manage CMS", path: "/cms" },
  { key: "13", label: "Manage FAQs", path: "/faq" },
  { key: "14", label: "Manage Sub-Admin", path: "/manage-subAdmin" },
  { key: "15", label: "Settings", path: "/settings" },
];

export const getRouteByPermissionLabel = (label?: string | null) => {
  if (!label) {
    return null;
  }

  return NAVIGATION_ITEMS.find((item) => item.label === label)?.path || null;
};

export const parsePermissions = (permissions: unknown): Permissions[] => {
  if (Array.isArray(permissions)) {
    return permissions as Permissions[];
  }

  if (typeof permissions === "string" && permissions.trim()) {
    try {
      const parsed = JSON.parse(permissions);
      if (Array.isArray(parsed)) {
        return parsed as Permissions[];
      }
    } catch {
      return [];
    }
  }

  return [];
};

export const getFirstViewablePermissionRoute = (permissions: unknown) => {
  const parsedPermissions = parsePermissions(permissions);
  const firstViewablePermission = parsedPermissions.find(
    (permission) => permission?.label && permission?.isView
  );

  if (!firstViewablePermission?.label) {
    return null;
  }

  return getRouteByPermissionLabel(firstViewablePermission.label);
};
